export default __webpack_public_path__ + "static/assa-abloy-logo-16014484dd50a6ba51bf5f43037c8208.png";